// src/components/store/sections/gallery/GalleryV56CyberhologramRoyalViolet.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV56CyberhologramRoyalViolet(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={56}
      archKey="cyber_hologram"
      archLabel="Cyber Neon Hologram Frames"
      palName="RoyalViolet"
      grad="from-violet-600 via-purple-600 to-indigo-700"
      lightBg="bg-violet-50"
      textCol="text-violet-700"
      borderCol="border-violet-200"
      btnCls="bg-violet-600 hover:bg-violet-700"
      hexCol="#8b5cf6"
      {...props}
    />
  );
}
